export class Breadcrumb {
	label: string;
	route: string;

	constructor(label: string, route: string) {
		this.label = label;
		this.route = route;
	}
}
